<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editCounter="selectedCounter"
    ></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(2)"
        title="Counter"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="counters"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-right">{{ item.needed}}</td>
            <td class="text-right">{{ item.received }}</td>
            <td class="text-right">{{ balance(item) }}</td>
            <td class="text-right">{{ item.dep }}</td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    v-if="checkRightStatus(18)"
                    @click="editCounter(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(10)"
                    @click="deleteCounter(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import counterService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
export default {
  name: "counter-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedCounter: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Needed",
          align: "right",
          value: "needed",
          sortable: true,
        },
        {
          text: "Received",
          value: "received",
          align: "right",
          sortable: true,
        },
        {
          text: "Balance",
          value: "balance",
          align: "right",
          sortable: true,
        },
        {
          text: "Received",
          value: "dep",
          align: "right",
          sortable: true,
        },
        {
          text: "Action",
          value: "action",
          align: "right",
          sortable: false,
        },
      ],
      counters: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "name",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Counter List";
  },
  components: {
    Create,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    balance(row){
      let balance = row.needed ? parseInt(row.needed) : 0
      balance -= row.received ? parseInt(row.received) : 0
      return balance
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false 
      this.createDialog = false
      return counterService.getAll().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.counters = response.data;
        return response;
      });
    },
    editCounter(counter) {
      this.selectedCounter = counter;
      this.editDialog = !this.editDialog;
    },
    deleteCounter(counter) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          counterService.delete(counter.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Counter has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
